import React from 'react';
import { Sidebar } from 'react-pro-sidebar';
import {
    LogoContainer,
    StyledIconButton,
    StyledIcon,
    StyledLogo,
    StyledMenu,
} from './SideMenu.styles';
import { Tooltip, useTheme, useAppSelector, RootState } from '../../../base';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../routes/RoutePaths';
import { getSideMenuItems } from './consts.SideMenu';
import { ISideMenuItem } from './interfaces.SideMenu';
import { useTranslation } from 'react-i18next';

import { organizationSelectors } from '../../../actions';
import { FeatureFlags } from '../../../common';

const SideMenu: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isReportsFeatureFlagOn = useAppSelector((state: RootState) =>
        organizationSelectors.isFlagOn(state, FeatureFlags.REPORTS)
    );
    const featureFlags = {
        [FeatureFlags.REPORTS]: isReportsFeatureFlagOn,
    };

    const renderSideMenuItem = (item: ISideMenuItem) => {
        return (
            <Tooltip
                title={item.tooltipText}
                placement="top-end"
                key={item.key}
            >
                <StyledIconButton
                    onClick={() => {
                        if (item.path && item.path in RoutePaths) {
                            navigate(
                                RoutePaths[item.path as keyof typeof RoutePaths]
                            );
                        }
                    }}
                    size="large"
                    aria-controls="account-menu"
                    aria-haspopup
                    aria-expanded
                >
                    <StyledIcon
                        className="side-menu-icon"
                        name={item.iconName}
                        size={40}
                    />
                </StyledIconButton>
            </Tooltip>
        );
    };

    return (
        <Sidebar
            backgroundColor={theme.palette.primary.main}
            rootStyles={{
                borderRight: 'none',
                borderLeft: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: '100%',
            }}
            collapsed={false}
            width="100px"
        >
            <LogoContainer>
                <StyledLogo src="/assets/logoIcon.svg" alt="Logo" />
            </LogoContainer>
            <StyledMenu>
                {getSideMenuItems(t, featureFlags)
                    .filter((item) => !item.hide)
                    .map(renderSideMenuItem)}
            </StyledMenu>
        </Sidebar>
    );
};

export default SideMenu;
